import { tw } from '@careinfo/tailwind';
import loadable from '@loadable/component';
import TicketIcon from '../../Icons/TicketIcon';
const TicketListComponent = loadable(
  () => import('../../components/Ticket/TicektList')
);

const TicketList = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <TicketIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Ticket</span>
      </div>
      <TicketListComponent />
    </>
  );
};

export default TicketList;
